module.exports = __webpack_public_path__ + "static/media/18.d4e1ce92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/18.jpg
// module id = 579
// module chunks = 0